var map = {
	"./": [
		9399,
		9,
		9399
	],
	"./AirtimeIcon": [
		2637,
		9,
		2637
	],
	"./AirtimeIcon.tsx": [
		2637,
		9,
		2637
	],
	"./ArrowBack": [
		4533,
		9,
		4533
	],
	"./ArrowBack.tsx": [
		4533,
		9,
		4533
	],
	"./CardPosIcon": [
		3604,
		9,
		3604
	],
	"./CardPosIcon.tsx": [
		3604,
		9,
		3604
	],
	"./CloseCircle": [
		7006,
		9,
		7006
	],
	"./CloseCircle.tsx": [
		7006,
		9,
		7006
	],
	"./DataIcon": [
		4036,
		9,
		4036
	],
	"./DataIcon.tsx": [
		4036,
		9,
		4036
	],
	"./InvestmentIcon": [
		3320,
		9,
		3320
	],
	"./InvestmentIcon.tsx": [
		3320,
		9,
		3320
	],
	"./KeyboardOpenIcon": [
		1516,
		9,
		1516
	],
	"./KeyboardOpenIcon.tsx": [
		1516,
		9,
		1516
	],
	"./LampIcon": [
		6314,
		9,
		6314
	],
	"./LampIcon.tsx": [
		6314,
		9,
		6314
	],
	"./MagnifingGlassIcon": [
		6653,
		9,
		6653
	],
	"./MagnifingGlassIcon.tsx": [
		6653,
		9,
		6653
	],
	"./MoneySendIcon": [
		1260,
		9,
		1260
	],
	"./MoneySendIcon.tsx": [
		1260,
		9,
		1260
	],
	"./SavingsIcon": [
		2377,
		9,
		2377
	],
	"./SavingsIcon.tsx": [
		2377,
		9,
		2377
	],
	"./ToggleIcon": [
		6069,
		9,
		6069
	],
	"./ToggleIcon.tsx": [
		6069,
		9,
		6069
	],
	"./WalletAddIcon": [
		9002,
		9,
		9002
	],
	"./WalletAddIcon.tsx": [
		9002,
		9,
		9002
	],
	"./WalletIcon": [
		5974,
		9,
		5974
	],
	"./WalletIcon.tsx": [
		5974,
		9,
		5974
	],
	"./index": [
		9399,
		9,
		9399
	],
	"./index.tsx": [
		9399,
		9,
		9399
	],
	"./magnifyingglass.svg": [
		9375,
		1,
		9375
	],
	"./types": [
		8505,
		9,
		8505
	],
	"./types.ts": [
		8505,
		9,
		8505
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3790;
module.exports = webpackAsyncContext;